import { Entity } from '@core/entities/entity'
import { ISkiaShapeBase } from '@core/entities/skia/SkiaShapeBase/ISkiaShapeBase'
import { GroupLabel, Point, ShapeTypes } from '@core/entities/skia/types'
import { Pin } from '../Pin'
import { Type } from 'class-transformer'
export class SkiaShapeBase<
  ExtendedType extends ISkiaShapeBase = ISkiaShapeBase,
> extends Entity<ExtendedType> {
  id: string
  type: ShapeTypes
  isHovered: boolean = false
  isSelected: boolean = false
  isEditing: boolean = false
  isBeingCreated?: boolean = false
  isNew?: boolean = false
  color?: string
  opacity?: number
  groupId?: string
  name?: string
  description?: string
  labels?: GroupLabel[]
  editLabels?: GroupLabel[]
  isActive?: boolean = false
  isInitial?: boolean = false
  linkedPermitsStatuses?: GroupLabel[]

  @Type(() => Pin)
  pins?: Pin[]

  dragCorners(): Point[] {
    throw new Error('Should be implemented in child class')
  }

  move(point: Point): void {
    throw new Error('Should be implemented in child class')
  }

  labelAnchor(): Point {
    throw new Error('Should be implemented in child class')
  }

  resizeOnDrag(params: { cornerIndex: number; x: number; y: number }): void {
    throw new Error('Should be implemented in child class')
  }

  isInBounds(point: Point): boolean {
    throw new Error('Should be implemented in child class')
  }

  updateFromPoints(startPoint: Point, endPoint: Point): void {
    throw new Error('Should be implemented in child class')
  }

  shapeCardAnchor(): Point {
    throw new Error('Should be implemented in child class')
  }

  select(): void {
    this.isSelected = true
  }

  deselect(): void {
    this.isSelected = false
  }

  startEditing(): void {
    this.isEditing = true
  }

  stopEditing(): void {
    this.isEditing = false
  }
}
